import React, { useState, useRef, useEffect } from "react";
import style from "./Slider.module.scss";
import personImg from "./images/persongirl.svg";
import vector from "./images/vector.svg";
import blackvector from "./images/blackvector.svg";
import { useNavigate } from "react-router-dom";

interface Slide {
  type: "text" | "image" | "full-image";
  title?: string;
  text?: string;
  buttonText?: string;
  link?: string;
  imageSrc: string;
}

const initialSlides: Slide[] = [
  {
    type: "text",
    title: "Здесь рождаются волшебные моменты!",
    text: "Создавайте свои события и покупайте билеты\n на уже существующие",
    buttonText: "Создать событие",
    link: "#",
    imageSrc: personImg,
  },
  {
    type: "text",
    title: "Здесь рождаются волшебные моменты!",
    text: "Создавайте свои события и покупайте билеты\n на уже существующие",
    buttonText: "Создать событие",
    link: "#",
    imageSrc: personImg,
  },
  {
    type: "text",
    title: "Здесь рождаются волшебные моменты!",
    text: "Создавайте свои события и покупайте билеты\n на уже существующие",
    buttonText: "Создать событие",
    link: "#",
    imageSrc: personImg,
  },
];

const Slider: React.FC = () => {
  const navigate = useNavigate();
  const [slides, setSlides] = useState<Slide[]>(initialSlides);
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);
  const startX = useRef<number>(0);
  const isDragging = useRef<boolean>(false);

  useEffect(() => {
    setSlides([...initialSlides]);
  }, []);

  const handleTouchStart = (e: React.TouchEvent) => {
    startX.current = e.touches[0].clientX;
    isDragging.current = true;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging.current) return;
    const moveX = e.touches[0].clientX - startX.current;
    setOffset(moveX);
  };

  const handleTouchEnd = () => {
    if (Math.abs(offset) > 50) {
      setCurrentSlide(
        (prev) => (prev + (offset < 0 ? 1 : -1) + slides.length) % slides.length
      );
    }
    setOffset(0);
    isDragging.current = false;
  };

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <>
      <div className={style["slider-container"]}>
        <div
          className={style.slider}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className={style["slides-container"]}
            style={{
              transform: `translateX(calc(-${
                currentSlide * 100
              }% + ${offset}px))`,
              transition: offset === 0 ? "transform 0.3s ease" : "none",
            }}
          >
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`${style.slide} ${
                  slide.type === "full-image" ? style["full-image-slide"] : ""
                }`}
              >
                {slide.type === "full-image" ? (
                  <img
                    className={style["full-image"]}
                    src={slide.imageSrc}
                    alt="event"
                  />
                ) : (
                  <div className={style["column-main"]}>
                    <div className={style["slide-text"]}>
                      {slide.title && (
                        <h2 className={style["slide-title"]}>{slide.title}</h2>
                      )}
                      {slide.text && (
                        <p className={style["slide-other-text"]}>
                          {slide.text}
                        </p>
                      )}
                      <div className={style["button-and-arrow"]}>
                        {slide.buttonText && (
                          <button
                            className={style["slide-button"]}
                            onClick={() => navigate("createEventPage")}
                          >
                            {slide.buttonText}
                          </button>
                        )}
                        {slide.type === "text" && (
                          <div
                            className={style["slide-vector-container"]}
                            onClick={() => navigate("createEventPage")}
                          >
                            <img
                              className={style["slide-vector"]}
                              src={blackvector}
                              alt="arrow"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <img
                      className={style["main-picture"]}
                      src={slide.imageSrc}
                      alt={slide.type === "text" ? "person" : "event"}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className={style.controls}>
            {currentSlide > 0 && (
              <img
                src={vector}
                className={style["left-control"]}
                onClick={goToPrevSlide}
                alt="Previous Slide"
              />
            )}
            {currentSlide < slides.length - 1 && (
              <img
                src={vector}
                className={style["right-control"]}
                onClick={goToNextSlide}
                alt="Next Slide"
              />
            )}
          </div>
        </div>
      </div>
      <button
        className={style["down-button"]}
        onClick={() => navigate("createEventPage")}
      >
        Создай своё событие
      </button>
    </>
  );
};

export default Slider;
